import React, { forwardRef, ForwardRefRenderFunction } from 'react';
import {
  Input,
  InputGroup,
  InputRightElement,
  useDisclosure,
  InputProps,
  Button,
} from '@chakra-ui/react';

const PasswordInputRenderer: ForwardRefRenderFunction<HTMLInputElement, InputProps> = (
  props,
  ref
) => {
  const { isOpen: show, onToggle } = useDisclosure();

  return (
    <InputGroup size="md">
      <Input
        placeholder="password"
        autoComplete="current-password"
        {...props}
        type={show ? 'text' : 'password'}
        ref={ref}
        paddingRight={16}
        _focus={{
          borderColor: 'primary.400',
        }}
      />
      <InputRightElement width="auto" paddingRight={4}>
        <Button
          aria-label={`${show ? 'Hide' : 'Show'} password`}
          variant="link"
          onClick={onToggle}
          color="black"
          textDecoration="underline"
          fontWeight="400"
          padding={0}
          width="auto"
        >
          {show ? 'Hide' : 'Show'}
        </Button>
      </InputRightElement>
    </InputGroup>
  );
};

export const PasswordInput = forwardRef(PasswordInputRenderer);
